import home from './home/home';
import error from './error';
import auth from './auth/auth';
import navbar from './navbar/navbar';
import correspondances from './miscellaneous/correspondances';
import weeklyScheduleCalendar from './miscellaneous/weekly_schedule_calendar';
import generic from './miscellaneous/generic';
import timeFormat from './miscellaneous/timeFormat';
import table from './miscellaneous/table';
import user from './admin/user';
import caregiver from './caregiver';
import client from './client';
import clientLead from './client_lead';
import dashboard from './dashboard/dashboard';
import dashboardWidgets from './dashboard/dashboardWidgets';
import playbooks from './playbooks';
import schedule from './schedule';
import skills from './skills';
import career from './career';
import tasks from './tasks';
import automations from './automations';
import metrics from './metrics';
import caseLang from './case';
import domainGuide from './domain_guide';
import routines from './routines';

export default {
  home,
  error,
  auth,
  navbar,
  correspondances,
  weeklyScheduleCalendar,
  generic,
  timeFormat,
  table,
  user,
  caregiver,
  client,
  clientLead,
  dashboard,
  dashboardWidgets,
  playbooks,
  schedule,
  skills,
  career,
  tasks,
  automations,
  metrics,
  case: caseLang,
  domainGuide,
  routines,
};
